export default __webpack_public_path__ + "static/media/earth.6dd35290.svg";